var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlashyJson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 95,
    fill: "#0b0f1a",
    stroke: "#3b5a8a",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 60,
    r: 12,
    fill: "#7aa2d4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 60,
    r: 12,
    fill: "#34d399"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 110,
    r: 12,
    fill: "#fbbf24"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 150,
    r: 10,
    fill: "#cbd5e1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 150,
    r: 10,
    fill: "#cbd5e1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 75 72 Q 85 90 95 105",
    stroke: "#3b5a8a",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 125 72 Q 115 90 105 105",
    stroke: "#3b5a8a",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 100 122 L 65 140",
    stroke: "#3b5a8a",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 100 122 L 135 140",
    stroke: "#3b5a8a",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 110,
    r: 15,
    fill: "none",
    stroke: "#60a5fa",
    strokeWidth: 1,
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashyJson);
export default __webpack_public_path__ + "static/media/flashy-json.9180a6926e5b354380e6b917f85b6b10.svg";
export { ForwardRef as ReactComponent };